import { render, staticRenderFns } from "./modalServico.vue?vue&type=template&id=453e53c6&scoped=true&"
import script from "./modalServico.vue?vue&type=script&lang=js&"
export * from "./modalServico.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=453e53c6&scoped=true&lang=css&"
import style1 from "./modalServico.vue?vue&type=style&index=1&id=453e53c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e53c6",
  null
  
)

export default component.exports